import $ from 'jquery'

$(document).ready(dhsv_vc_research_areas())

function dhsv_vc_research_areas() {
  // let terms = $('.dhsv_vc_research_areas').attr('data-terms')
  // console.log(jQuery.parseJSON(terms)) //eslint-disable-line
  let arrPosition = []
  $('.person-position-js li').each(function() {
    let title = $.trim($(this).text())
    arrPosition.push(title)
  })

  function orderTerm() {
    let objPosition = []
    $('.active[role="tabpanel"] .accordion-item').each(function() {
      let title = $.trim(
        $(this)
          .find('.accordion-title')
          .text()
      )

      let obj = arrPosition.find(x => x === title)
      let index = arrPosition.indexOf(obj)

      let $item = $(this).detach()

      objPosition[index] = $item
    })
    console.log(objPosition) //eslint-disable-line
    objPosition.forEach(el => {
      $('.tab-content .active .accordion-main').append(el)
    })
  }

  setTimeout(orderTerm, 1000)

  $('.research-area .nav-link').on('click', function() {
    setTimeout(orderTerm, 1000)
  })

  $('.dhsv_vc_research_areas').each(function() {
    let highestBox
    const elementNode = $(this).find('.js-equal')
    if ($(elementNode).length > 1) {
      highestBox = 0
    }
    $(elementNode).each(function() {
      if ($(this).outerHeight(true, true) > highestBox) {
        highestBox = $(this).outerHeight(true, true)
      }
    })
    $(elementNode).height(highestBox)

    $('.nav-link', this).click(function() {
      const tabHref = $(this).attr('href')
      window.location.href = tabHref

      $('html, body').animate(
        {
          scrollTop: $('.research-area').offset().top - 150,
        },
        600
      )
    })

    if (window.location.hash) {
      const windowHash = window.location.hash.replace('#', '')
      $('.nav-link', this).removeClass('active')
      $(`.nav-link[href='#${windowHash}']`, this).addClass('active')
      $('.tab-pane', this).removeClass('show active')
      $(`.tab-pane[id='${windowHash}']`, this).addClass('show active')
    }
  })
}
